import React, { memo, useCallback, useMemo } from "react"
import { graphql, useStaticQuery } from "gatsby"
import { ProductVariant } from "shopify-storefront-api-typings"

import { useCart } from "@app/hooks/useCart"
import { FormButton } from "@app/components/Form/FormButton"

type Props = {
  quantity: number
  activeVariant: ProductVariant
}

export const ProductPairingsAddToCart: React.FC<Props> = memo(({ quantity, activeVariant }) => {
  const { product: productForm } = useStaticQuery<GatsbyTypes.ProductFormAddToCartQuery>(graphql`
    query ProductFormAddToCart {
      product: sanityTemplateProduct {
        additionalAddToCart
        additionalSoldOut
      }
    }
  `)
  const { addToCart, loading } = useCart()

  const handleClick = useCallback(() => {
    activeVariant?.id && addToCart(activeVariant.id, quantity, [])
  }, [activeVariant, addToCart, quantity])

  const isSoldOut = useMemo(() => activeVariant && !activeVariant?.availableForSale, [activeVariant])

  return (
    <FormButton
      isDisabled={isSoldOut || loading}
      isLoading={loading}
      onClick={handleClick}
      size="md"
      title={isSoldOut ? productForm?.additionalSoldOut : productForm?.additionalAddToCart}
      aria-label={isSoldOut ? productForm?.additionalSoldOut : productForm?.additionalAddToCart}
      variant="pdpAddToCart"
      w="full"
    >
      {isSoldOut ? productForm?.additionalSoldOut : productForm?.additionalAddToCart}
    </FormButton>
  )
})
